<ng-container *ngFor="let option of questionData?.choices">
  <ng-container *ngFor="let data of option.optionValue">
    <span [mathjax]="data.data"></span>
  </ng-container>
</ng-container>
<span [mathjax]="mathjaxContent"></span>
<span id="tikz-content"></span>
